
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fcP5z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d42f5b7535302467$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $d42f5b7535302467$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': "\u30C7\u30FC\u30BF\u3092\u96C6\u8A08",
    'extension.charts.aggregateDataDescription': "\u8907\u6570\u306E\u5217\u304C\u540C\u3058\u5024\u3092\u6301\u3064\u5834\u5408\u306F\u3001\u5024\u3092 1 \u3064\u306E\u30C7\u30FC\u30BF \u30DD\u30A4\u30F3\u30C8\u306B\u307E\u3068\u3081\u307E\u3059\u3002",
    'extension.charts.category': "\u30AB\u30C6\u30B4\u30EA",
    'extension.charts.customizeTab': "\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA",
    'extension.charts.dataMissing.details': "\u3053\u306E\u30B0\u30E9\u30D5\u306E\u30BD\u30FC\u30B9\u3068\u306A\u308B\u8868\u304C\u30DA\u30FC\u30B8\u3067\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    'extension.charts.dataMissing.title': "\u8868\u793A\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
    'extension.charts.dataTab': "\u30C7\u30FC\u30BF",
    'extension.charts.defaultColumnName': "\u30B3\u30E9\u30E0 {0}",
    'extension.charts.defaultTitle': "\u7121\u984C\u306E\u30B0\u30E9\u30D5",
    'extension.charts.defaultYLabel': "\u7121\u984C\u306E\u8EF8",
    'extension.charts.extensionTitle': "\u30B0\u30E9\u30D5",
    'extension.charts.height': "\u9818\u57DF\u306E\u9AD8\u3055\u3092\u6C7A\u3081\u308B",
    'extension.charts.height.large': "\u9577\u304F\u3059\u308B",
    'extension.charts.height.medium': "\u65E2\u5B9A",
    'extension.charts.height.small': "\u77ED\u304F\u3059\u308B",
    'extension.charts.horizontal.orientation.label': "\u6A2A",
    'extension.charts.insert.tooltip': "\u30B0\u30E9\u30D5\u3092\u633F\u5165",
    'extension.charts.legend': "\u51E1\u4F8B",
    'extension.charts.legend.auto': "\u81EA\u52D5",
    'extension.charts.legend.bottom': "\u4E0B",
    'extension.charts.legend.left': "\u5DE6",
    'extension.charts.legend.position': "\u51E1\u4F8B\u306E\u4F4D\u7F6E",
    'extension.charts.legend.right': "\u53F3",
    'extension.charts.legend.show': "\u51E1\u4F8B\u3092\u8868\u793A",
    'extension.charts.legend.top': "\u4E0A",
    'extension.charts.options.label': "\u30B0\u30E9\u30D5\u306E\u30AA\u30D7\u30B7\u30E7\u30F3",
    'extension.charts.options.tooltip': "\u30B0\u30E9\u30D5\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u5909\u66F4",
    'extension.charts.orientation.label': "\u5411\u304D",
    'extension.charts.seriesNames': "\u30C7\u30FC\u30BF\u7CFB\u5217",
    'extension.charts.showPoints': "\u30C7\u30FC\u30BF \u30DD\u30A4\u30F3\u30C8\u3092\u8868\u793A",
    'extension.charts.smoothLines': "\u306A\u3081\u3089\u304B\u306A\u7DDA",
    'extension.charts.style': "\u30B9\u30BF\u30A4\u30EB",
    'extension.charts.title': "\u30BF\u30A4\u30C8\u30EB",
    'extension.charts.type.bar': "\u68D2",
    'extension.charts.type.fieldDescription': "\u30B0\u30E9\u30D5\u306E\u7A2E\u985E",
    'extension.charts.type.line': "\u6298\u308C\u7DDA",
    'extension.charts.type.pie': "\u5186",
    'extension.charts.userTitle': "\u30BF\u30A4\u30C8\u30EB",
    'extension.charts.vertical.orientation.label': "\u7E26",
    'extension.charts.xAxis': "X \u8EF8",
    'extension.charts.xLabel': "X \u8EF8\u306E\u30E9\u30D9\u30EB",
    'extension.charts.yLabel': "Y \u8EF8\u306E\u30E9\u30D9\u30EB"
};

});


//# sourceMappingURL=ja.bf77fd0d.js.map
